export default __webpack_public_path__ + "static/media/users.f62c1f6b.svg";